module.exports = __webpack_public_path__ + "static/blog27-fa947f7c15add777fbb7b6996fbb7bfe.png";